'use strict';

import React, {
    useCallback,
    useEffect,
    useState
} from 'react';

import {
    Button,
    ButtonProps
} from 'primereact/button';


type InputProps = ButtonProps;

type DefaultProps = {};
const defaultProps : Required<DefaultProps> = {};

type Props = {
    altKeyLabel? : string;
    altKeyIcon? : ButtonProps['icon'];
};

export type ComponentProps = InputProps & DefaultProps & Props;

type AllProps = InputProps & Required<DefaultProps> & Props;

export type ReferenceType = {};


const AltKeyButton = ( props : AllProps, forwardedRef : ReferenceType ) => {
    const {
              altKeyLabel,
              altKeyIcon,
              label,
              icon,
              ...buttonProps
          }                     = props,
          [ altKey, setAltKey ] = useState<boolean>( false ),
          onDocumentKeyDown     = useCallback(
              ( event : KeyboardEvent ) => {
                  if ( event.altKey ) {
                      setAltKey( true );
                  }
              },
              []
          ),
          onDocumentKeyUp       = useCallback(
              ( event : KeyboardEvent ) => {
                  setAltKey( false );
              },
              []
          );

    useEffect( () => {
        document.addEventListener( 'keydown', onDocumentKeyDown, true );
        document.addEventListener( 'keyup', onDocumentKeyUp, true );

        return () => {
            document.removeEventListener( 'keydown', onDocumentKeyDown, true );
            document.removeEventListener( 'keyup', onDocumentKeyUp, true );
        }
    }, [] );

    return <Button
        {...buttonProps}
        label={altKey && altKeyLabel ? altKeyLabel : label}
        icon={altKey && altKeyIcon ? altKeyIcon : icon}
    />;
}
AltKeyButton.displayName = 'AltKeyButton';

export default AltKeyButton;
